import { RESPONSE_TYPES } from "@constants/response-types";

import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";

export class UserPasswordChangeService extends HttpService {
  userPasswordChange = async (
    baseAuthUrl: string,
    data: Record<string, TObject>
  ): Promise<TObject> => {
    try {
      const apiResponse = await this.patch(
        `${baseAuthUrl}/api/user/password/change

        `,
        data
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
}
